export const types = {
  LOADING: 'LOADING',
  CLEAR_STATE: 'CLEAR_STATE',
  CLEAR_PROJECT_STATE: 'CLEAR_PROJECT_STATE',
  TOGGLE_CALCULATOR: 'TOGGLE_CALCULATOR',
  POPUP_EXPORT_PROJECT_DATA: 'POPUP_EXPORT_PROJECT_DATA',
  POPUP_TOO_MANY_PROJECTS: 'POPUP_TOO_MANY_PROJECTS',
  POPUP_TOO_MANY_PROJECTS_HIDE: 'POPUP_TOO_MANY_PROJECTS_HIDE',
  AUTH_ERROR: 'AUTH_ERROR',
  SET_AUTH_ERROR: 'SET_AUTH_ERROR',
  CLEAR_AUTH_ERROR: 'CLEAR_AUTH_ERROR',
  AFTER_EMAIL_RECOVERY: 'AFTER_EMAIL_RECOVERY',
  ADD_USER: 'ADD_USER',
  EDIT_USER: 'EDIT_USER',
  LOGGED_IN: 'LOGGED_IN',
  SAVE_USER_DATA: 'SAVE_USER_DATA',
  SAVE_COMPANY_DATA: 'SAVE_COMPANY_DATA',
  SAVE_PROFILE_IMAGE: 'SAVE_PROFILE_IMAGE',
  SAVE_COMPANY_IMAGE: 'SAVE_COMPANY_IMAGE',
  SAVE_PROJECT_IMAGE: 'SAVE_PROJECT_IMAGE',
  LOAD_PROJECT_FULL_DETAILS: 'LOAD_PROJECT_FULL_DETAILS',
  LOAD_PROJECT_PART_DETAILS: 'LOAD_PROJECT_PART_DETAILS',
  UPDATE_CURRENT_PROJECT: 'UPDATE_CURRENT_PROJECT',
  UPDATE_PROJECT_DETAILS: 'UPDATE_PROJECT_DETAILS',
  SAVE_NEWS: 'SAVE_NEWS',
  ADD_PROJECT: 'ADD_PROJECT',
  ADD_PROJECT_LIST: 'ADD_PROJECT_LIST',
  TOGGLE_COMMENTS: 'TOGGLE_COMMENTS',
  TOGGLE_HOURS: 'TOGGLE_HOURS',
  TOGGLE_PRICES: 'TOGGLE_PRICES',
  HIDE_POPUP: 'HIDE_POPUP',
  SHOW_POPUP: 'SHOW_POPUP',
  SHOW_DELETE_PROJECT_POPUP: 'SHOW_DELETE_PROJECT_POPUP',
  ADD_PROJECT_FULL: 'ADD_PROJECT_FULL',
  ADD_PROJECT_FULL_LIST: 'ADD_PROJECT_FULL_LIST',
  REMOVE_PROJECT: 'REMOVE_PROJECT',
  POPUP_PROJECT: 'POPUP_PROJECT',
  PROJECT_FROM_TOKEN: 'PROJECT_FROM_TOKEN',
  CHANGE_PRICE_RANGE: 'CHANGE_PRICE_RANGE',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  UPDATE_PROJECT_FULL_DETAILS:  'UPDATE_PROJECT_FULL_DETAILS',
  UPDATE_CURRENT_PROJECT_MODULES:  'UPDATE_CURRENT_PROJECT_MODULES',
  UPDATE_PROJECT_STATUS: 'UPDATE_PROJECT_STATUS',
  UPDATE_SELETED_CELL: 'UPDATE_SELETED_CELL',
  UPDATE_EDITING_CELL: 'UPDATE_EDITING_CELL',
  REPLACE_CURRENT_PROJECT_MODULES:  'REPLACE_CURRENT_PROJECT_MODULES',
  UPDATE_BACKUP_POSITION: 'UPDATE_BACKUP_POSITION',
  UPDATE_UNDO_COUNT: 'UPDATE_UNDO_COUNT',
  UPDATE_FROM_UNDO: 'UPDATE_FROM_UNDO',
  UPDATE_PROJECT_BACKUP: 'UPDATE_PROJECT_BACKUP',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_REDIRECT_URL: 'SET_REDIRECT_URL'
}
